export function isFeatureActive(feature: string) {
  return !!(window.featuresList
    && window.featuresList
      .split(',')
      .map(f => f.trim())
      .includes(feature))
}
